import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { AlertaService } from '../../../services/alerta.service';
import { NgForm } from '@angular/forms';
import { HolidayGroup } from '../../../models/holiday-group';
import { select, Store } from '@ngrx/store';
import { distinctUntilChanged, map } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { Division } from '../../../models/division';
import { Area } from '../../../models/area';
import { findAreasCatalogAct, findDivisionsCatalogAct } from '../../../store/catalog-offer/catalog-offer.actions';
import { findHolidayGroupAct, resetHolidayGroupAct, saveHolidayGroupAct, updateHolidayGroupAct } from '../../../store/holidays/holidays.action';
import { HolidayConfiguration } from '../../../models/holiday-configuration';
import { HolidayList } from '../../../models/holiday-list';


@Component({
  selector: 'app-holidays-edit',
  standalone: false,
  templateUrl: './holidays-edit.component.html',
  styleUrl: './holidays-edit.component.css'
})
export class HolidaysEditComponent {

  holidaysForm!: NgForm;
  holidayGroup: HolidayGroup = new HolidayGroup();
  loading: boolean = false;
  violations: any;
  divisions: Division[] = [];
  areas: Area[] = [];
  private alerta = inject(AlertaService);
  
  ngOnInit(): void {
    this.holidaysGroupStore.dispatch(resetHolidayGroupAct());
    this.route.paramMap.subscribe(params => {
      const id: number = + (params.get('id') || '0');
      if(id > 0){
        this.holidaysGroupStore.dispatch(findHolidayGroupAct({ id }));
      }else{
        this.holidayGroup = new HolidayGroup();
        this.holidayGroup.active = true;
        this.loading = false;
      }
    });

    this.catalogOfferStore.dispatch(findDivisionsCatalogAct());
    this.catalogOfferStore.dispatch(findAreasCatalogAct());

  }
  constructor(
    private holidaysGroupStore: Store<{holidayGroupRdc: any}>,
    private catalogOfferStore: Store<{catalogOfferRdc: any}>,
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef
  ){
    this.holidayGroup = new HolidayGroup();

    this.holidaysGroupStore.pipe(
      select('holidayGroupRdc'),
      map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
        holidayGroup: state.holidayGroup,
        violations: state.violations,
        loading: state.loading
      })),
      // evita repeticiones
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev) === JSON.stringify(curr)
      )
    ).subscribe(({ holidayGroup, violations, loading }) => {
      this.violations = violations;
      this.holidayGroup = JSON.parse(JSON.stringify(holidayGroup));
      // Ordenar lista de vacaciones 
      //this.holidayGroup.holidayLists[0].holidayConfigurations[0].initialYear
      this.holidayGroup.holidayLists.forEach(holidayList => {
        holidayList.holidayConfigurations.sort((a, b) => a.initialYear - b.initialYear);
      });
      this.loading = loading;
      this.cd.markForCheck(); // fuerza la actualización de la vista

      if(this.holidaysForm){
        Object.keys(this.holidaysForm.controls).forEach(controlName => {
          const control = this.holidaysForm.controls[controlName];
          if (this.violations[controlName]) {
            control.setErrors({ backend: true }); // Marca error
          }
        });
      }
    });

    this.catalogOfferStore.pipe(
      select('catalogOfferRdc'),
      map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
        divisions: state.divisions,
        areas: state.areas
      })),
      // evita repeticiones
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev) === JSON.stringify(curr)
      )
    ).subscribe(({ divisions, areas }) => {
      this.divisions = divisions;
      this.areas = areas;
    });
    
  }

  onSubmitHolidays(holidaysForm: NgForm): void {
    this.loading = true;
    this.holidaysForm = holidaysForm;
    const holidayGroupCopy = JSON.parse(JSON.stringify(this.holidayGroup));

    if (holidayGroupCopy.id > 0) {
      this.holidaysGroupStore.dispatch(updateHolidayGroupAct({ holidayGroupUpdated: holidayGroupCopy }))
    } else {
      this.holidaysGroupStore.dispatch(saveHolidayGroupAct({ holidayGroupNew: holidayGroupCopy}))
    }
  }
  


  hoveredRow: number | null = null;
  hoveredCol: number | null = null;

  isSelected(listIndex: number, divisionId: number, areaId: number): boolean {
    const list = this.holidayGroup.holidayLists?.[listIndex];
    return list?.holidayDivisionAreas.some(d =>
      d.id.divisionId === divisionId && d.id.areaId === areaId
    ) ?? false;
  }

  onCheckboxChange(listIndex: number, division: Division, area: Area, event: any): void {
    const checked = event.target.checked;
    const list = this.holidayGroup.holidayLists?.[listIndex];
    if (!list) return;
  
    const index = list.holidayDivisionAreas.findIndex(d =>
      d.id.divisionId === division.id && d.id.areaId === area.id
    );
  
    if (checked && index === -1) {
      // Agrega nuevo vínculo
      list.holidayDivisionAreas.push({
        id: {
          holidayListId: list.id,
          divisionId: division.id,
          areaId: area.id
        },
        division,
        area
      });
    } else if (!checked && index !== -1) {
      // Elimina vínculo
      list.holidayDivisionAreas.splice(index, 1);
    }
  }

  onMouseEnter(row: number, col: number) {
    this.hoveredRow = row;
    this.hoveredCol = col;
  }

  onMouseLeave() {
    this.hoveredRow = null;
    this.hoveredCol = null;
  }

  trackById(index: number, item: any): number {
    return item.id;
  }
  addConfiguration(listIndex: number){
    const newHolidayConfiguration = new HolidayConfiguration();
    const listHL = this.holidayGroup.holidayLists?.[listIndex];

    listHL.holidayConfigurations = [...listHL.holidayConfigurations, newHolidayConfiguration];
    listHL.holidayConfigurations = listHL.holidayConfigurations.map((row, index) => ({
      ...row,
      rowIndex: index
    }));

  }

  addList(){
    const newHolidayList = new HolidayList();
    this.holidayGroup.holidayLists = [...this.holidayGroup.holidayLists, newHolidayList ];
  }
}
